import React__default from 'react';

/*
  Using existing logic from React 18 support in EGDS repository.
*/
const useLegacyCustomId = () => React__default.useMemo(() => Math.random().toString(36).substring(7), []);
/*
  This utility unlocks the use of React.useId but falls back to a custom ID generator for environments that are not on React 18 yet.
  This useId hook as part of React 18 because the new render methods expect the IDs to be identical when the component is rendered on the server and client.
  Using Math random never guarantees that the IDs will be the same on both the server and client.
  Once React 17 is not supported anymore by EGDS, this utility can be removed/ replaced.
*/
const useIdCompatibility = React__default.useId ?? useLegacyCustomId;
export { useIdCompatibility };